module.exports = __webpack_public_path__ + "static/img/banner4.affb4bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone/banner4.jpg
// module id = G1w0
// module chunks = 2